// extracted by mini-css-extract-plugin
export default {"layout":"AdminLayout_layout__BRILD","mainContent":"AdminLayout_mainContent__HCwSQ"};